export default "__VITE_ASSET__BOGIIP4N__"